import React from 'react';
import styles from './index.module.scss';

/* eslint-disable react/prop-types */
export default ({ children, className }) => <div className={`${styles.root} ${className || ''}`}>{children}</div>;
